import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {EditDesignPage} from '@mintdata-wsp/wsp/ui/pages/visualDesigner/EditDesignPage';
import {FlowEditorPage} from '@mintdata-wsp/wsp/ui/pages/visualDesigner/FlowEditorPage';
import {WspPage} from '@mintdata-wsp/wsp/ui/pages/workspace/WspPage';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Route, RouteComponentProps, Switch} from 'react-router';

@observer
export class LoggedInPages extends BasePage<RouteComponentProps<any>, any>
{
    render():JSX.Element
    {
        return (
            <Switch>
                <Route exact path={`${paths.index()}`} component={WspPage} />
                <Route exact path={`${paths.search()}`} component={WspPage} />
                <Route exact path={`${paths.designs()}`} component={WspPage} />
                <Route exact path={`${paths.applications()}`} component={WspPage} />

                <Route exact path={`${paths.templates()}`} component={WspPage} />
                <Route exact path={`${paths.template(':templateName')}`} component={WspPage} />

                <Route path={`${paths.spaces(':projectId')}`} component={WspPage} />
                <Route path={`${paths.settings()}`} component={WspPage} />

                <Route
                    path={`${paths.flowEditor(':projectId', ':designId', ':functionId')}`}
                    component={FlowEditorPage}
                />
                <Route
                    path={`${paths.design(':projectId', ':designId')}`}
                    component={EditDesignPage}
                />

                <Route path="*" component={WspPage} />
            </Switch>
        );
    }
}
